import React, { useState } from 'react';
import { Typography } from '@mui/material';
import CsvUpload from '../../components/CsvUpload';
import ErrorTable from './components/ErrorTable';
import { RowErrorGroup } from './types';
import { PageWrapper, Title } from '../common/styled';

interface UploadCsvPageProps {
  school: string;
  onUpload: (file: File) => void;
  uploading: boolean;
  errorRows: RowErrorGroup[] | null;
  resetErrors: () => void;
}

const UploadCsvPage: React.FC<UploadCsvPageProps> = ({
  onUpload,
  uploading,
  errorRows,
  resetErrors
}) => {
  const [file, setFile] = useState<File | null>(null);
  const [resetKey, setResetKey] = useState(0);

  const handleFileChange = (f: File | null) => {
    setFile(f);
    resetErrors();
  };

  const handleUploadClick = () => {
    if (file) onUpload(file);
  };

  const clearAll = () => {
    setFile(null);
    resetErrors();
    setResetKey((k) => k + 1); // force input clear
  };

  const showErrorsTable = errorRows !== null && errorRows.length > 0;
  const showSuccessMessage = errorRows !== null && errorRows.length === 0;

  return (
    <>
      <Title>Import Users</Title>
      <CsvUpload
        file={file}
        uploading={uploading}
        resetKey={resetKey}
        onFileChange={handleFileChange}
        onUpload={handleUploadClick}
        onRemoveFile={clearAll}
      />

      {showSuccessMessage && (
        <PageWrapper>
          <Typography variant='body1' color='success.main'>
            File processed successfully. No validation errors found.
          </Typography>
        </PageWrapper>
      )}

      {showErrorsTable && (
        <PageWrapper>
          <Typography variant='h6' sx={{ mb: 2 }}>
            Errors
          </Typography>
          <ErrorTable rows={errorRows || []} />
        </PageWrapper>
      )}
    </>
  );
};

export default UploadCsvPage;
